<template>
  <!-- 上传视频：填充 -->
  <SpriteUploadSection
    :shape="shape"
    :is-sprite="isSprite"
    :is-video="isVideo"
    :max-count="maxCount"
    :sprite-items="spriteItems"
  />

  <!-- 配置序列帧默认图 -->
  <template v-if="isSprite">
    <SpriteDefaultImageSection
      :shape="shape"
      :sprite-items="spriteItems"
      :max-count="maxCount"
    />
  </template>

  <!-- 默认显示 -->
  <SpriteDefaultShowSection
    :shape="shape"
    :is-sprite="isSprite"
    :is-video="isVideo"
    :sprite-items="spriteItems"
  />

  <!-- 配置序列帧：重复播放和播放次数等 -->
  <SpriteConfigSection
    :shape="shape"
    :is-sprite="isSprite"
    :is-video="isVideo"
    :sprite-items="spriteItems"
  />

  <!-- 预览 -->
  <SpritePreviewSection
    :shape="shape"
    :is-sprite="isSprite"
    :is-video="isVideo"
  />
</template>

<script lang="ts" setup>
import { Shape, ShapeType } from '@/services/shape';
import { canUse } from '@/utils/can-use.utils';
import { computed } from 'vue';
import { PropType } from 'vue';

const props = defineProps({
  shape: {
    type: Object as PropType<Shape>,
    required: true
  }
});

// 是否可以使用多序列帧视频
const isMulti = computed(() => canUse('multi-sprite-video').valid);
const maxCount = computed(() => {
  if (isMulti.value) {
    // 视频最多2个，图片最多5个
    return isVideo.value ? 2 : 5;
  }
  return 1;
});

const spriteItems = computed(() => {
  const shape = props.shape;
  const spriteItems = shape.getSpriteMulitItems();
  return isMulti.value ? spriteItems : [spriteItems[0]];
});

const spriteType = computed(() => props.shape.attrs.spriteType ?? 'sprite');

const isSprite = computed(
  () => props.shape.type == ShapeType.Sprite && spriteType.value == 'sprite'
);

const isVideo = computed(
  () =>
    spriteType.value == 'video' || props.shape.type == ShapeType.VideoWatchface
);
</script>
